// ConstructionCards.js
import React from 'react';
import { Card, CardContent, Typography, IconButton, Box } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { image, image1, image2 } from './ImageConstants';

const ConstructionCards = ({ navigate }) => {
  const cardStyle = {
    backgroundColor: '#d8ccba',
    borderTopLeftRadius: '24px',
    borderBottomRightRadius: '24px',
    overflow: 'hidden',
    width: '100%',
    height: 220,
    boxShadow: '0 13px 30px rgba(0, 0, 0, 0.4), 0 6px 10px rgba(0, 0, 0, 0.35)',
    cursor: 'pointer',
    transform: 'perspective(1000px)',
    transition: 'transform 0.4s ease, box-shadow 0.4s ease',
    '&:hover': {
      transform: 'perspective(1000px) scale(1.03) rotateX(2deg)',
      boxShadow: '0 28px 40px rgba(0, 0, 0, 0.5), 0 10px 20px rgba(0, 0, 0, 0.4)',
    },
  };

  const constructions = [
    { title: 'New Building Construction', image: image, onClick: () => navigate('/constructions') },
    { title: 'Interiors', image: image1, onClick: () => navigate('/interiors') },
    { title: 'Renovations', image: image2, onClick: () => navigate('/construction-get-started') },
  ];

  return (
    <>
      {constructions.map((item, index) => (
        <Box mb={2} key={index}>
          <Card onClick={item.onClick} sx={cardStyle}>
            <Box
              sx={{
                height: '70%',
                backgroundImage: `url(${item.image})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                borderBottomRightRadius: '24px',
                position: 'relative',
                boxShadow: '0 8px 24px rgba(0, 0, 0, 0.7)',
                border: '1px solid black',
                '&::after': {
                  content: '""',
                  position: 'absolute',
                  bottom: 0,
                  left: 0,
                  width: '100%',
                  height: '8px',
                  borderBottomRightRadius: '24px',
                  zIndex: 2,
                },
              }}
            />
            <CardContent
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                height: '30%',
                px: 2,
                py: 1,
                backgroundColor: '#d8ccba',
              }}
            >
              <Typography variant="body1" fontWeight="600" color="#333" noWrap sx={{ flex: 1, pr: 1 }}>
                {item.title}
              </Typography>
              <IconButton sx={{ color: '#333' }}>
                <ArrowForwardIosIcon fontSize="small" />
              </IconButton>
            </CardContent>
          </Card>
        </Box>
      ))}
    </>
  );
};

export default ConstructionCards;   